import { View } from "react-native"
import { H2, TealText } from "@/components/standard/BFText"
import { PrimaryDarkButton } from "@/components/buttons/CommonButtons"
import { preQualLandingPageIntentClick } from "@/analytics/events/preQual"
import { router } from "expo-router"
import Svg, { Path, type SvgProps } from "react-native-svg"
import { Vertical } from "@/components/standard/BFLayout"

function HeaderSquiggly(props: SvgProps) {
  return (
    <Svg width={117} height={17} viewBox="0 0 117 17" fill="none" {...props}>
      <Path
        d="M26.013 16.67l-.61-1.113c4.377-1.71 8.865-3.274 13.325-4.723-1.22.186-2.41.259-3.63.445-6.371.864-10.416 1.209-18.948 1.307l-.14-1.24c8.395-.132 12.273-.396 18.784-1.226 3.047-.466 6.177-.67 9.197-1.023.748-.06 1.357-.152 2.105-.212 1.108-.334 2.327-.52 3.435-.854C34.072 7.653 7.754 6.686 2.267 3.906l-1.551-.86 1.69-.313c4.404-.618 14.378-.608 19.641-.535l1.469-.005c9.087.037 18.59.777 27.815 1.45l.443-.012c5.347.334 11.137.052 16.678-.411 3.269-.17 6.565-.455 9.945-.479C85.877.941 93.55-.452 101.668.555l-.138 1.173c-5.985-.73-11.858-.107-17.703 1.006 1.884.096 3.906.225 5.735.549 8.09-.085 16.511.272 24.989 1.005l1.579.143-1.108.937c-1.994 1.566-5.374 1.589-8.338 1.713-.305.047-.748.06-1.025-.008 1.164.645 2.161 1.37 2.826 2.255l.998 1.328-1.662-.404c-4.433-1.077-18.23-1.655-25.627-2.005-1.025-.007-1.884-.095-2.604-.15-2.189-.05-4.544-.018-6.732-.067-3.823.036-7.619-.042-11.58-.04-1.69.313-3.408.74-5.097 1.054-10.278 2.448-20.639 4.635-30.168 7.627zM72.275 4.39c-1.191.073-2.52.111-3.74.298-5.651.315-11.33.745-16.816.377l-.443.013C42.05 4.404 32.548 3.664 23.599 3.66l-1.468.005c-4.405.015-11.996-.14-16.927.23 9.42 2.288 36.376 3.048 49.258 3.162C60.17 5.912 66.097 5.06 72.11 4.47c.028-.114.166-.08.166-.08zm-25.874 5.655c-1.108.334-2.188.554-3.296.888 1.413-.38 2.936-.614 4.35-.994-.444.013-.749.06-1.054.106zm26.151-4.381c-1.108.334-2.327.52-3.435.854 2.355-.031 4.932.233 7.674.417.416.1 1.303.075 2.605.15 6.898-.013 13.796-.025 20.667-.527a72.784 72.784 0 00-8.007-1.463l-.416-.1c-.692-.17-1.413-.224-2.105-.392-5.763.168-11.414.484-16.983 1.06zm30.503 1.862c-2.41.259-4.793.404-7.148.435 3.907.225 7.481.61 10.029.989-.748-.544-1.662-1.007-2.881-1.424zm-3.27-2.242c1.247.303 2.355.572 3.408 1.07.139.033.305-.047.443-.013.887-.026 1.94-.132 2.965-.125 1.911-.018 4.127-.082 5.706-.543-5.042-.38-9.945-.728-14.766-.813.72.054 1.413.222 2.244.424z"
        fill="#75FAD4"
      />
    </Svg>
  )
}

export const BecomeMemberCTA = () => {
  return (
    <Vertical className={"p-5 gap-5 items-center"}>
      <View>
        <H2 className={"text-off-white text-center"}>
          Become a Member for{"\n"}
          <TealText>fast & free</TealText> ARVs & CMAs
        </H2>
        <HeaderSquiggly />
      </View>
      <View className={"w-[250px]"}>
        <PrimaryDarkButton
          size={"md"}
          title={"Unlock Access"}
          testID={"unlock-access"}
          onPress={() => {
            preQualLandingPageIntentClick({
              intent: "SignUp",
              id: "unlock-access",
              title: "Unlock Access",
            })
            router.push("/register")
          }}
        />
      </View>
    </Vertical>
  )
}
